const categories = [
  {
    code: "A",
    name: "avontuurlijk",
    title: "Avontuurlijke beroepen",
    text:
      "<p>Jij durft veel en zoekt de spanning op. Geen achtbaan is te gek voor jou. Je trekt er graag op uit en houdt ervan om buiten te zijn. Alles wat je al kent wordt snel saai, jij houdt van verrassingen. Er wordt altijd gezocht naar dappere mensen! <br />Misschien word jij dit later:</p>",
    beroepen: [
      "Politieagent",
      "brandweerman (-vrouw)",
      "militair",
      "(drone)piloot",
      "astronaut",
      "boswachter",
      "reisleider",
      "ontdekkingsreiziger",
      "bewaker"
    ]
  },
  {
    code: "B",
    name: "creatief",
    title: "Creatieve beroepen",
    text:
      "<p>Jouw hoofd zit vol ideeën en die komen er op allerlei manieren uit: je speelt een instrument, kan leuke verhalen schrijven, mooie dingen maken of de leukste filmpjes editen (met heel veel likes).<br />Met jouw creatieve talent kun je heel veel kanten op, overal hebben ze graag mensen met goede ideeën! Je kunt bij een bedrijf aan de slag of voor jezelf beginnen.<br />Misschien word jij dit later:</p>",
    beroepen: [
      "Kunstenaar",
      "architect",
      "acteur",
      "game-/mode-/web-designer",
      "vlogger",
      "kok",
      "cameraman(vrouw)",
      "muzikant",
      "model",
      "e-sporter"
    ]
  },
  {
    code: "C",
    name: "verzorgend",
    title: "Verzorgende beroepen",
    text:
      "<p>Jij hebt een sensor voor hoe het met de mensen en dieren om je heen gaat. Als je ergens kunt helpen dan doe je dat. Zo doe jij graag mee met acties om geld in te zamelen. Ook in de klas weten anderen je te vinden als ze hulp nodig hebben. Voor jou is er volop werk in de toekomst!<br />Misschien word jij dit later:</p>",
    beroepen: [
      "Dokter",
      "verpleegster",
      "fysiotherapeut",
      "docent",
      "kapper",
      "schoonheidsspecialiste",
      "secretaresse",
      "pedagogisch medewerker",
      "tandarts",
      "dierenarts",
      "hondentrimmer",
      "kraamhulp",
      "diëtist"
    ]
  },
  {
    code: "D",
    name: "actief",
    title: "Actieve beroepen",
    text:
      "<p>Stilzitten is niks voor jou. Jij bent graag bezig en steekt je handen uit de mouwen. Jij hebt doorzettingsvermogen en gaat voor het beste. Tof dat je daar je beroep van kunt maken. Je kunt alle kanten op, er is veel vraag naar handige en actieve mensen!<br />Misschien word jij dit later:</p>",
    beroepen: [
      "Timmerman",
      "gymleraar",
      "automonteur",
      "stratenmaker",
      "prof-sporter",
      "elektricien",
      "fietsenmaker",
      "chauffeur",
      "stukadoor",
      "hovenier",
      "zweminstructeur",
      "activiteitenbegeleider",
      "fitness-instructeur"
    ]
  },
  {
    code: "E",
    name: "Onderzoekend",
    title: "Onderzoekende beroepen",
    text:
      "<p>Toen jij nog in de box lag, onderzocht je al of de spijlen eruit konden. En je hebt al regelmatig een stuk speelgoed uit elkaar geschroefd. Jij bent nieuwsgierig en gaat op onderzoek uit. Dat kan in de natuur zijn, maar ook op het gebied van elektronica. Ze hebben jou hard nodig in de toekomst! Begin maar alvast met programmeren.<br />Misschien word jij dit later:</p>",
    beroepen: [
      "Bioloog",
      "laborant",
      "(computer)programmeur",
      "hacker",
      "viroloog",
      "journalist",
      "archeoloog",
      "detective",
      "onderzoeker",
      "uitvinder"
    ]
  },
  {
    code: "F",
    name: "ondernemend",
    title: "Ondernemende beroepen",
    text:
      "<p>Jij houdt er van om dingen te organiseren en te regelen. Je hebt veel ideeën en weet anderen te overtuigen om mee te doen. Je zorgt ervoor dat je je werk op school zo goed mogelijk maakt. Als je je werk goed doet, kun je veel geld verdienen, dat spreekt jou wel aan. In de toekomst is er genoeg werk voor organisatietalenten zoals jij!<br /> Misschien word jij dit later:</p>",
    beroepen: [
      "Directeur",
      "ondernemer (eigen bedrijf)",
      "boer",
      "burgemeester",
      "accountmanager",
      "hotelmanager",
      "verkoper"
    ]
  }
];

export default categories;
